import { useEffect } from 'react';

import { useYM } from 'YM/Context';
import { GoalType } from 'YM/declare';
import type { CommonMetricsParams } from 'YM/Rules/general';

export function useRecordMetrics() {
    const { triggerYM } = useYM();

    useEffect(() => {
        triggerYM<CommonMetricsParams>({
            data: { meeting_role: undefined, setting_permission_camera: undefined, setting_permission_mic: undefined },
            goal: GoalType.RECORD_PAGE_VIEW,
        });
    }, []);
}
